import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Property1Default from "../components/Property1Default";
import SizeMediumStateDefaultSt1 from "../components/SizeMediumStateDefaultSt1";
import Footer from "../components/Footer";
import styles from "./Services.module.css";

const Services = () => {
  const navigate = useNavigate();

  const onButtonClick = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const onAboutMeTextClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutMeContainer1Click = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const onAboutMeContainer3Click = useCallback(() => {
    navigate("/staff");
  }, [navigate]);

  return (
    <div className={styles.services}>
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.medicalIconiPhysicalTherapParent}>
            <img
              className={styles.medicalIconiPhysicalTherap}
              alt=""
              src="/medicaliconiphysicaltherapy1.svg"
            />
            <div className={styles.logo}>
              <img className={styles.logo1Icon} alt="" src="/logo-1.svg" />
              <b className={styles.personal}>
                <p className={styles.jJPhysical}>{`J &J Physical`}</p>
                <p className={styles.jJPhysical}>Therapy</p>
              </b>
            </div>
          </div>
          <div className={styles.taskbaar}>
            <div className={styles.aboutMe}>
              <div className={styles.aboutMe1} onClick={onAboutMeTextClick}>
                Home
              </div>
            </div>
            <div className={styles.aboutMe2} onClick={onAboutMeContainer1Click}>
              <div className={styles.aboutMe3}>About</div>
            </div>
            <Property1Default
              sectionTitle="Services"
              property1DefaultBorderRadius="10px"
              property1DefaultBackgroundColor="rgba(93, 37, 214, 0.63)"
              property1DefaultBoxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              property1DefaultPadding="10px"
              property1DefaultBoxSizing="border-box"
            />
            <div className={styles.aboutMe2} onClick={onAboutMeContainer3Click}>
              <div className={styles.aboutMe3}>Our Staff</div>
            </div>
          </div>
          <SizeMediumStateDefaultSt1
            linkText="Contact Us"
            showDownloadIcon={false}
            sizeMediumStateDefaultStCursor="pointer"
            sizeMediumStateDefaultStBorder="none"
            sizeMediumStateDefaultStBackgroundColor="#000"
            sizeMediumStateDefaultStHeight="56px"
            sizeMediumStateDefaultStJustifyContent="center"
            sizeMediumStateDefaultStPadding="var(--padding-base) var(--padding-xl)"
            sizeMediumStateDefaultStBoxSizing="border-box"
            sizeMediumStateDefaultStWidth="unset"
            sizeMediumStateDefaultStZIndex="unset"
            resumeDisplay="inline-block"
            onButtonContainerClick={onButtonClick}
          />
        </div>
      </div>
      <div className={styles.testimonial}>
        <div className={styles.frameParent}>
          <div className={styles.physicalTherapyServicesParent}>
            <b className={styles.physicalTherapyServices}>
              Physical Therapy Services
            </b>
            <div className={styles.freeInjuryScreeningsContainer}>
              <ol className={styles.freeInjuryScreeningsSpinal}>
                <li className={styles.freeInjuryScreenings}>
                  Free Injury Screenings
                </li>
                <li className={styles.freeInjuryScreenings}>
                  Spinal Decompression
                </li>
                <li className={styles.freeInjuryScreenings}>Rehabilitation</li>
                <li
                  className={styles.freeInjuryScreenings}
                >{`Pain Manigment & Meditation`}</li>
                <li>Health and Wellness</li>
              </ol>
            </div>
          </div>
          <div className={styles.groupParent}>
            <img className={styles.groupChild} alt="" src="/group-3.svg" />
            <img className={styles.groupItem} alt="" src="/group-21.svg" />
            <img className={styles.groupInner} alt="" src="/polygon-3.svg" />
            <div className={styles.ellipseDiv} />
            <div className={styles.samMoghadamKhamseh0sa8d74ioWrapper}>
              <img
                className={styles.samMoghadamKhamseh0sa8d74ioIcon}
                alt=""
                src="/sammoghadamkhamseh0sa8d74iodiunsplash-1@2x.png"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.servicesInner}>
        <div className={styles.pexelsRyutaroTsukata5473182Parent}>
          <img
            className={styles.pexelsRyutaroTsukata5473182Icon}
            alt=""
            src="/pexelsryutarotsukata5473182-1@2x.png"
          />
          <div className={styles.freeInjuryScreeningsContainer1}>
            <p className={styles.jJPhysical}>
              <b>Free Injury Screenings</b>
            </p>
            <p className={styles.jJPhysical}>
              <b>&nbsp;</b>
            </p>
            <p className={styles.quisLoremConsequat}>
              Quis lorem consequat est varius nulla imperdiet pulvinar. Faucibus
              nibh mi leo fames tortor ultrices felis. Facilisis nunc hac sed
              lectus vehicula massa dui faucibus lacus. Euismod orci quis mauris
              purus accumsan justo nunc velit sagittis.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.spinalDecompressionQuisLoreParent}>
        <div className={styles.spinalDecompressionQuisContainer}>
          <p className={styles.spinalDecompression1}>
            <b>Spinal Decompression</b>
          </p>
          <p className={styles.jJPhysical}>
            <b>&nbsp;</b>
          </p>
          <p className={styles.jJPhysical}>
            Quis lorem consequat est varius nulla imperdiet pulvinar. Faucibus
            nibh mi leo fames tortor ultrices felis. Facilisis nunc hac sed
            lectus vehicula massa dui faucibus lacus. Euismod orci quis mauris
            purus accumsan justo nunc velit sagittis.
          </p>
          <p className={styles.jJPhysical}>&nbsp;</p>
          <p className={styles.jJPhysical}>
            {" "}
            lorem consequat est varius nulla imperdiet pulvinar. Faucibus nibh
            mi leo fames tortor ultrices felis. Facilisis nunc hac sed lectus
            vehicula massa dui faucibus lacus. Euismod orci quis mauris purus
            accumsan justo nunc velit sagittis.
          </p>
        </div>
        <img
          className={styles.spine405259912801Icon}
          alt=""
          src="/spine4052599-1280-1@2x.png"
        />
      </div>
      <div className={styles.pexelsCliffBooth40578652Parent}>
        <img
          className={styles.pexelsCliffBooth40578652Icon}
          alt=""
          src="/pexelscliffbooth4057865-2@2x.png"
        />
        <div className={styles.athleticRehabilitationOremCWrapper}>
          <div className={styles.athleticRehabilitationOremContainer}>
            <p className={styles.jJPhysical}>
              <b>Athletic Rehabilitation</b>
            </p>
            <p className={styles.jJPhysical}>
              <b>&nbsp;</b>
            </p>
            <p className={styles.oremConsequatEst}>
              orem consequat est varius nulla imperdiet pulvinar. Faucibus nibh
              mi leo fames tortor ultrices felis. Facilisis nunc hac sed lectus
              vehicula massa dui faucibus lacus. Euismod orci quis mauris purus
              accumsan justo nunc velit sagittis.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.rehabilitationOremConsequatParent}>
        <div className={styles.rehabilitationOremConsequatContainer}>
          <p className={styles.jJPhysical}>
            <b>Rehabilitation</b>
          </p>
          <p className={styles.jJPhysical}>
            <b>&nbsp;</b>
          </p>
          <p className={styles.oremConsequatEst}>
            orem consequat est varius nulla imperdiet pulvinar. Faucibus nibh mi
            leo fames tortor ultrices felis. Facilisis nunc hac sed lectus
            vehicula massa dui faucibus lacus. Euismod orci quis mauris purus
            accumsan justo nunc velit sagittis.
          </p>
        </div>
        <img
          className={styles.pexelsAneteLusina52406771Icon}
          alt=""
          src="/pexelsanetelusina5240677-1@2x.png"
        />
      </div>
      <div className={styles.pexelsCliffBooth40578651Parent}>
        <img
          className={styles.pexelsCliffBooth40578651Icon}
          alt=""
          src="/pexelscliffbooth4057865-1@2x.png"
        />
        <div className={styles.rehabilitationOremConsequatContainer}>
          <p className={styles.jJPhysical}>
            <b>{`Pain Manigment & Meditation`}</b>
          </p>
          <p className={styles.jJPhysical}>
            <b>&nbsp;</b>
          </p>
          <p className={styles.oremConsequatEst}>
            orem consequat est varius nulla imperdiet pulvinar. Faucibus nibh mi
            leo fames tortor ultrices felis. Facilisis nunc hac sed lectus
            vehicula massa dui faucibus lacus. Euismod orci quis mauris purus
            accumsan justo nunc velit sagittis.
          </p>
        </div>
      </div>
      <div className={styles.healthWellnessOremConsequParent}>
        <div className={styles.rehabilitationOremConsequatContainer}>
          <p className={styles.jJPhysical}>
            <b>{`Health & Wellness`}</b>
          </p>
          <p className={styles.jJPhysical}>
            <b>&nbsp;</b>
          </p>
          <p className={styles.oremConsequatEst}>
            orem consequat est varius nulla imperdiet pulvinar. Faucibus nibh mi
            leo fames tortor ultrices felis. Facilisis nunc hac sed lectus
            vehicula massa dui faucibus lacus. Euismod orci quis mauris purus
            accumsan justo nunc velit sagittis.
          </p>
        </div>
        <img
          className={styles.pexelsPixabay2757681Icon}
          alt=""
          src="/pexelspixabay275768-1@2x.png"
        />
      </div>
      <div className={styles.frameGroup}>
        <div className={styles.frameContainer}>
          <div className={styles.jjPhysicalTherapyParent}>
            <div className={styles.jjPhysicalTherapyContainer}>
              <span className={styles.jjPhysical}>{`J&J Physical `}</span>
              <span>Therapy</span>
            </div>
            <div className={styles.fromPainTo}>
              From pain to progress, we're with you every step.
            </div>
          </div>
          <div className={styles.copyrightJjPhysicalTherapyWrapper}>
            <div
              className={styles.copyrightJjPhysical}
            >{` © Copyright j&j physical  therapy  inc.`}</div>
          </div>
        </div>
        <div className={styles.frameDiv}>
          <div className={styles.helpParent}>
            <div className={styles.help}>Help</div>
            <div className={styles.supportWebinarPlatformsContainer}>
              <p className={styles.jJPhysical}>Support</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Webinar Platforms</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Consult</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Video Chats</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Features</div>
            <div className={styles.ugentCareSpecialContainer}>
              <p className={styles.jJPhysical}>Ugent Care</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Special Programs</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>File Sharing</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Company</div>
            <div className={styles.aboutUsCareersContainer}>
              <p className={styles.jJPhysical}>About Us</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Careers</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Contact Us</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.contactUs1}>Contact Us</div>
            <div className={styles.junesjjtherapycom1800000}>
              <p className={styles.jJPhysical}>JuneS@jjtherapy.com</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>1-800-000-000</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>2384 W. Lane</p>
              <p className={styles.jJPhysical}>Somewhere, NY 10800</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
